// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cf-container {
  container-type: inline-size;
  /*min-width: 768px;*/
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Content wrapper for flex layout */
.cf-container .cf-content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

/* scrollable table container */
.cf-container .cf-table-container {
  flex: 1 1 auto;
  margin-top: 20px;
  min-height: 0;
}

.cf-container .cf-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
}

.cf-container .cf-table thead th {
  box-shadow: inset 0 -1px 0 0 var(--border-primary);
  text-align: right;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: #1e1f2f;
  vertical-align: bottom;
  white-space: nowrap;
}
.cf-container .cf-table thead th:nth-child(1) {
  /*padding:0px !important;    */
}
.cf-container .cf-table thead th:first-child {
  width: 22px;
  box-shadow: none;
}

.cf-container .cf-table thead th:last-child {
  width: 22px;
  box-shadow: none;
}

.cf-container .cf-table tbody td {
  vertical-align: middle;
  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);
}

.cf-container .cf-table tbody td:first-child {
  width: 22px;
  border: none;
}

.cf-container .cf-table tbody td:last-child {
  width: 22px;
  border: none;
}
/*.cf-container .cf-table tbody tr:nth-child(2n) {
    background-color: #EFEFEF;
}    */

/* Table header styles */
.cf-table-header {
  padding: 8px 0;
  text-align: left;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  color: var(--text-subheader);
}

.cf-currency-label {
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.cf-container .cf-table thead th.cf-table-header-year {
  text-align: right;
  padding: 0px 8px 8px 8px;
  min-width: 80px;
  max-width: 100px;
}

.cf-container .cf-table thead th.cf-table-header-label {
  text-align: left;
  padding: 0px 8px 8px 8px;
  min-width: 180px;
  max-width: 180px;
}

.cf-header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.cf-header-fy {
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: var(--text-subheader);
}

.cf-header-date {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--text-subheader);
}

/* Table body styles */
.cf-container .cf-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  text-align: right;
  font-size: 16px;
  padding: 0;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-primary);
  box-sizing: border-box;
}

.cf-container .cf-table tbody td.cf-table-label-cell {
  text-align: left;
  padding-left: 8px;
  min-width: 180px;
  max-width: 180px;
}

.cf-container .cf-table tbody td.cf-table-cell {
  text-align: right;
  padding: 0 8px 0 0;
  min-width: 100px;
  max-width: 100px;
}

.cf-label-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.cf-expand-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
  transform: rotate(-90deg);
  flex-shrink: 0;
  color: var(--text-primary);
  path {
    fill: currentColor;
  }
}

.cf-expand-icon.expanded {
  transform: rotate(0deg);
}

.cf-label-text {
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
}

.cf-indented-label {
  font-size: 16px;
  line-height: 24px;
  padding-left: 32px !important;
}

.cf-cell-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /*gap: 2px;*/
  padding: 8px 0;
}

.cf-cell-value {
  font-size: 16px;
  line-height: 18px;
  color: var(--text-primary);
  height: 24px;
}

.cf-cell-growth {
  font-size: 14px;
  line-height: 100%;
  font-weight: 400;
  height: 16px;
}

.cf-cell-growth.positive {
  color: var(--text-up-color);
}

.cf-cell-growth.negative {
  color: var(--text-down-color);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/CashFlowWidget/CashFlowWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;;MAEM;;AAEN,wBAAwB;AACxB;EACE,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".cf-container {\n  container-type: inline-size;\n  /*min-width: 768px;*/\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Content wrapper for flex layout */\n.cf-container .cf-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n}\n\n/* scrollable table container */\n.cf-container .cf-table-container {\n  flex: 1 1 auto;\n  margin-top: 20px;\n  min-height: 0;\n}\n\n.cf-container .cf-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n}\n\n.cf-container .cf-table thead th {\n  box-shadow: inset 0 -1px 0 0 var(--border-primary);\n  text-align: right;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  padding: 0;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: #1e1f2f;\n  vertical-align: bottom;\n  white-space: nowrap;\n}\n.cf-container .cf-table thead th:nth-child(1) {\n  /*padding:0px !important;    */\n}\n.cf-container .cf-table thead th:first-child {\n  width: 22px;\n  box-shadow: none;\n}\n\n.cf-container .cf-table thead th:last-child {\n  width: 22px;\n  box-shadow: none;\n}\n\n.cf-container .cf-table tbody td {\n  vertical-align: middle;\n  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);\n}\n\n.cf-container .cf-table tbody td:first-child {\n  width: 22px;\n  border: none;\n}\n\n.cf-container .cf-table tbody td:last-child {\n  width: 22px;\n  border: none;\n}\n/*.cf-container .cf-table tbody tr:nth-child(2n) {\n    background-color: #EFEFEF;\n}    */\n\n/* Table header styles */\n.cf-table-header {\n  padding: 8px 0;\n  text-align: left;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  color: var(--text-subheader);\n}\n\n.cf-currency-label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.cf-container .cf-table thead th.cf-table-header-year {\n  text-align: right;\n  padding: 0px 8px 8px 8px;\n  min-width: 80px;\n  max-width: 100px;\n}\n\n.cf-container .cf-table thead th.cf-table-header-label {\n  text-align: left;\n  padding: 0px 8px 8px 8px;\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.cf-header-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n}\n\n.cf-header-fy {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 18px;\n  color: var(--text-subheader);\n}\n\n.cf-header-date {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--text-subheader);\n}\n\n/* Table body styles */\n.cf-container .cf-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  text-align: right;\n  font-size: 16px;\n  padding: 0;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  box-sizing: border-box;\n}\n\n.cf-container .cf-table tbody td.cf-table-label-cell {\n  text-align: left;\n  padding-left: 8px;\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.cf-container .cf-table tbody td.cf-table-cell {\n  text-align: right;\n  padding: 0 8px 0 0;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.cf-label-with-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.cf-expand-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n  transform: rotate(-90deg);\n  flex-shrink: 0;\n  color: var(--text-primary);\n  path {\n    fill: currentColor;\n  }\n}\n\n.cf-expand-icon.expanded {\n  transform: rotate(0deg);\n}\n\n.cf-label-text {\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  max-width: 100%;\n}\n\n.cf-indented-label {\n  font-size: 16px;\n  line-height: 24px;\n  padding-left: 32px !important;\n}\n\n.cf-cell-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  /*gap: 2px;*/\n  padding: 8px 0;\n}\n\n.cf-cell-value {\n  font-size: 16px;\n  line-height: 18px;\n  color: var(--text-primary);\n  height: 24px;\n}\n\n.cf-cell-growth {\n  font-size: 14px;\n  line-height: 100%;\n  font-weight: 400;\n  height: 16px;\n}\n\n.cf-cell-growth.positive {\n  color: var(--text-up-color);\n}\n\n.cf-cell-growth.negative {\n  color: var(--text-down-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
